/**
 * 抽選演出スキップフラグ
 */
export const PRODUCTION_END_FLAG = {
  FALSE: 0,
  TRUE: 1,
};
